import React, { useState } from 'react';
import theme from './ProjectCatalogImportItem.module.scss';
import { ProjectImportableProduct } from '@/services/profile-catalog-products';
import { Trans } from '@lingui/react/macro';
import { ProductCard } from '../../products/ProductCard';
import { Button, ButtonBar, Badge } from '@ygtechnologies/rubus-ui';
import { faCheck, faPlus } from '@fortawesome/pro-light-svg-icons';
import { SimplePriceDisplay } from '../../products/PriceDisplay';

export interface ProjectCatalogImportListProps {
    item: ProjectImportableProduct;
    onImport(item: ProjectImportableProduct): Promise<void>;
}

export const ProjectCatalogImportItem: React.FC<ProjectCatalogImportListProps> = ({ item, onImport }) => {
    const [saving, setSaving] = useState(false);

    const handleImport = async () => {
        try {
            setSaving(true);
            await onImport(item);
        } finally {
            setSaving(false);
        }
    };

    const getImportButton = () => {
        if (item.isAlreadyImported) {
            return (
                <Badge variant="success" size="lg" iconLeft={faCheck} appearance="subtle">
                    <Trans>Product already exists in this project</Trans>
                </Badge>
            );
        }

        if (!item.hasPermissionsToImport) {
            return (
                <>
                    <Trans>Not allowed to import product of this category</Trans>
                </>
            );
        }

        return (
            // <SimpleTooltip
            //     content={<Trans>Not allowed to import product of this category</Trans>}
            //     disabled={item.hasPermissionsToImport}>
            <Button variant="tertiary" icon={faPlus} size="sm" onClick={handleImport} loading={saving}>
                <Trans>Add to project</Trans>
            </Button>
            // </SimpleTooltip>
        );
    };

    return (
        <div className={theme.item} key={item.product.id}>
            <ProductCard
                product={item.product}
                catalog="profile"
                priceElement={<SimplePriceDisplay currencyMode="profile" finalPrice={item.product.defaultPrice || 0} />}
                bottomElement={
                    <ButtonBar className={theme.buttons}>
                        <ButtonBar.Right>{getImportButton()}</ButtonBar.Right>
                    </ButtonBar>
                }
            />

            {/* {!item.isImportable && (
                        <div className={theme.disabledOverlay}>{item.isAlreadyImported && getDisableText(item)}</div>
                    )} */}
        </div>
    );
};
